import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

const commonLanguages = ['javascript', 'typescript', 'python', 'rust', 'bash', 'shell', 'html', 'css', 'json', 'markdown'];

export function highlightCode(code: string, language?: string): string {
    if (language && hljs.getLanguage(language)) {
        try {
            return hljs.highlight(code, { language, ignoreIllegals: true }).value;
        } catch (error) {
            console.warn(`Failed to highlight code for language ${language}:`, error);
        }
    }
    
    try {
        return hljs.highlightAuto(code, commonLanguages).value;
    } catch (error) {
        console.warn('Failed to auto-highlight code:', error);
        return hljs.highlight(code, { language: 'plaintext' }).value;
    }
}

export function extractLanguageFromCodeBlock(element: HTMLElement): string | null {
    const pre = element.closest('pre');
    if (pre) {
        const classList = Array.from(pre.classList);
        const langClass = classList.find(cls => cls.startsWith('language-'));
        if (langClass) {
            return langClass.replace('language-', '');
        }
    }
    return null;
}

export function applyHighlightingToContainer(container: ParentNode): void {
    const codeBlocks = container.querySelectorAll('pre > code:not(.hljs)');
    
    codeBlocks.forEach((codeElement) => {
        const code = codeElement.textContent || '';
        const pre = codeElement.parentElement as HTMLElement | null;
        if (!pre) return;
        
        const classList = Array.from(pre.classList);
        const langClass = classList.find(cls => cls.startsWith('language-'));
        const language = langClass ? langClass.replace('language-', '') : null;
        
        const highlighted = highlightCode(code, language || undefined);
        
        const codeEl = codeElement as HTMLElement;
        codeEl.innerHTML = highlighted;
        codeEl.classList.add('hljs');
        
        const wrapper = document.createElement('div');
        wrapper.className = 'code-block-wrapper';
        
        const copyBtn = document.createElement('button');
        copyBtn.className = 'code-copy-btn';
        copyBtn.setAttribute('data-tooltip', 'Copy');
        copyBtn.setAttribute('data-code', code);
        
        const icon = document.createElement('i');
        icon.setAttribute('data-lucide', 'copy');
        copyBtn.appendChild(icon);
        
        wrapper.appendChild(copyBtn);
        
        pre.parentNode?.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        
        if (language) {
            pre.classList.add('hljs');
        }
    });
}

export function applyHighlightingToCodeBlocks(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    applyHighlightingToContainer(doc.body);
    
    return doc.body.innerHTML;
}